const SvgIcon = ({size = '24', color = '#a59e9e'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1080"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path1078"
      fill={color}
      fillOpacity="0.98"
      strokeWidth="1"
      d="M10.762 2.99v4.776a3 3 0 0 1-3.016 3.003H2.992a2.93 2.93 0 0 1-2.118-.886A2.95 2.95 0 0 1 0 7.766V3.003A3 3 0 0 1 2.992 0h4.766a2.98 2.98 0 0 1 2.118.886 2.95 2.95 0 0 1 .886 2.105M24 3.004v4.763a3.027 3.027 0 0 1-2.992 3.003H16.23a3.08 3.08 0 0 1-2.13-.874 3 3 0 0 1-.875-2.129V3.003a2.95 2.95 0 0 1 .887-2.117A2.98 2.98 0 0 1 16.23 0h4.765A3.03 3.03 0 0 1 24 3.003m0 13.23v4.764A3.027 3.027 0 0 1 21.008 24H16.23a3.08 3.08 0 0 1-2.155-.85 2.98 2.98 0 0 1-.874-2.129v-4.763a2.95 2.95 0 0 1 .886-2.117 2.98 2.98 0 0 1 2.118-.886h4.766a3.03 3.03 0 0 1 3.004 3.003zm-13.238.013v4.763a3.027 3.027 0 0 1-3.016 2.99H2.992A2.98 2.98 0 0 1 0 21.01v-4.763a3.027 3.027 0 0 1 2.992-3.015h4.766a3.08 3.08 0 0 1 2.13.886c.562.566.876 1.332.874 2.129"
    ></path>
  </svg>
);

export default SvgIcon;
